module.exports = "/_next/static/images/caade2511860b2e3a824de18c0429dd5-terms-and-conditions.svg.webp";